import { IS_DEVELOPMENT } from 'config/env'

const isDevelopmentStorageOverride = sessionStorage.isDevelopment
export default isDevelopmentStorageOverride === undefined
  ? IS_DEVELOPMENT
  : isDevelopmentStorageOverride === 'true'
